module.exports = __webpack_public_path__ + "static/media/PodCasts.fd6c4f4a.png";